import React from 'react'
import './Footer.css'

// Importa tus imágenes o íconos
import logo from '../assets/images/logo-anabarber-blanco.png'
import whatsappIcon from '../assets/icons/whatsapp-brands-solid-full.svg'
import mailIcon from '../assets/icons/envelope-regular-full.svg'

const Footer = () => {
  const year = new Date().getFullYear()

  return (
    <footer className="footer-container" id="footer">
      <div className="footer-content">
        {/* Columna 1: Logo */}
        <div className="footer-col footer-logo">
          <img src={logo} alt="Logo Dra. Barber" className="footer-logo-img" />
          <p className="footer-name">Dra. Ana Lourdes Barber</p>
          <p className="footer-specialty">Especialista en Endocrinología</p>
        </div>

        {/* Columna 2: Dónde atenderse */}
        <div className="footer-col footer-info">
          <h3>Consulta Médica en Santiago</h3>
          <p><strong>Dirección:</strong> Av. Salvador 95, Of. 509, Providencia.</p>
          <p><strong>Horarios con cita:</strong><br />Lunes a Viernes, 9:00 a 18:00 hrs.</p>
        </div>

        {/* Columna 3: Redes de contacto */}
        <div className="footer-col footer-contacto">
          <h3>Contacto y Redes</h3>
          <div className="contacto-item">
            <img src={whatsappIcon} alt="WhatsApp" />
            <p>+569 4442 8019</p>
          </div>
          <div className="contacto-item">
            <img src={whatsappIcon} alt="WhatsApp" />
            <p>+562 2209 2879</p>
          </div>
          <div className="contacto-item">
            <img src={whatsappIcon} alt="WhatsApp" />
            <p>+562 2205 0181</p>
          </div>
          <div className="contacto-item">
            <img src={mailIcon} alt="Correo" />
            <p>anilubar@hotmail.com</p>
          </div>
        </div>
      </div>

      {/* Línea inferior con derechos reservados */}
      <div className="footer-bottom">
        <p>© {year} Dra. Ana Lourdes Barber — Todos los derechos reservados.</p>
      </div>
    </footer>
  )
}

export default Footer
